import Sortable from 'sortablejs'
import DataTable from 'datatables.net-bs5';
import 'datatables.net-rowgroup-dt';
import $ from 'jquery'
import {createDatePicker, createTomSelectElement} from "../utils/helpers";
import {readFormParams, updateUrlState} from "../utils/url-sync";

/**
 * Registers general-purpose UI Unpoly compilers: TomSelect, Sortable, DataTables,
 * and solution dropdown behavior.
 */
export function registerUICompilers() {
	up.compiler('.date-picker, .month-picker, .time-picker, .datetime-picker', function (element, data) {
		const picker = createDatePicker(element, data);
		return function () {
			picker?.destroy();
		};
	});

	up.compiler('.tom-select', function (element) {
		createTomSelectElement(element);
	})

  // Drag-and-drop constraint group behavior
  up.compiler('.constraint-pattern-group', function (element, data) {
    new Sortable(element, {
      group: 'constraints',
      sort: false,
      handle: '.handle',
      onEnd: function (event) {
        const details = event.to.dataset
        const patternId = details['patternId']
        const constraintId = event.item.dataset['id']
        const level = details['group']
        up.render({
          url: `/patterns/updateConstraintDetails?id=${constraintId}&patternId=${patternId}&level=${level}`,
          target: '#main',
          scroll: 'target'
        }).catch((err) => {
          console.log(err)
        })
      }
    })
  })

  // DataTables
	up.compiler('.datatable', function (element, data) {
		let collapsedGroups = {};
		let isRowGroupingRequired = data.rowGrouping;
		let stopPaging = data.stopPaging;
		let disableSearch = data.disableSearch;
		let options = {
			language: {
				info: '_PAGES_のページ _PAGE_',
				infoEmpty: 'データーがありません',
				infoFiltered: '(フィルター後 _MAX_ から表示)',
				lengthMenu: '表示 _MENU_ 件',
				zeroRecords: 'データーがありません',
				search: '検索:'
			},
			initComplete: function () {
				this.api()
					.columns()
					.every(function () {
						let column = this;
						let title = column.footer().textContent;

						// Create input element
						let input = document.createElement('input');
						input.placeholder = title;
						input.classList.add('form-control', 'form-control-sm');
						if(title === 'Date and Time') {
							// createDatePicker(input, {})
						}
						column.footer().replaceChildren(input);

						// Event listener for user input
						input.addEventListener('keyup', () => {
							if (column.search() !== this.value) {
								column.search(input.value).draw();
							}
						});
					});
			}
		};
		if (isRowGroupingRequired) {
			options.rowGroup = {

				dataSrc: function(row) {
					let index = 0;
					if(data.groupIndex) index = data.groupIndex
					return row[index];
				},
				startRender: function (rows, group) {
					let collapsed = !!collapsedGroups[group];

					rows.nodes().each(function (r) {
						r.style.display = collapsed ? 'none' : '';
					});

					// Add category name to the <tr>. NOTE: Hardcoded colspan
					return $('<tr/>')
						.append('<td colspan="8"><b>' + group + ' (' + rows.count() + ')</b></td>')
						.attr('data-name', group)
						.toggleClass('collapsed', collapsed);
				}
			}
		}

		if(stopPaging) {
			options.paging = false
		}

		if(disableSearch) {
			options.searching = true;
			options.dom = "lrti";
		}

		let table = new DataTable(element, options);
		if (isRowGroupingRequired) {
			$('.datatable tbody tr.dtrg-start').each(function () {
				let name = $(this).data('name');
				collapsedGroups[name] = !collapsedGroups[name];
			});
			table.draw(false);

			$('.datatable tbody').on('click', 'tr.dtrg-start', function () {
				let name = $(this).data('name');
				collapsedGroups[name] = !collapsedGroups[name];
				table.draw(false);
			});
		}
	});

	// Solution page solution select.
	// The controlling form uses up-autosubmit (no up-history) to swap #runs/#solutions/
	// #run-timing-info/#solution-details on date/runId change. Because the submitted
	// runId/solutionId can be stale for the new date, we do NOT let Unpoly write the
	// request URL. Instead this compiler — which recompiles every time #solutions is
	// swapped — writes the canonical URL from the SERVER-RESOLVED form values, so the
	// address bar always reflects what is actually displayed (never a stale run/solution).
	up.compiler('.solution-page-solution-select', function (element) {
		function loadSolutionDetails(value) {
			up.render({ url: `/solution/solution/${value}`, target: '#solution-details', scroll: 'target' })
		}
		// The select lives inside the controlling GET form; read the resolved date/runId
		// from it so the URL carries the full, consistent selection state.
		const form = element.closest('#solution-index-form') || element.closest('form')

		// Normalize '0'/empty placeholder values to null so they are dropped from the URL.
		function cleanId(value) {
			return (value && value !== '0') ? value : null
		}
		function currentSelectionParams(solutionId) {
			return { ...readFormParams(form, ['date', 'runId']), solutionId: cleanId(solutionId) }
		}

		// User picks a solution: load details and push a distinct history entry.
		element.addEventListener('change', function (event) {
			const value = event.target.value
			loadSolutionDetails(value)
			updateUrlState({ params: currentSelectionParams(value), replace: false })
		})

		// Runs on initial load AND after every date/runId swap (fragment recompile):
		// sync the URL to the resolved selection, replacing any stale runId/solutionId.
		const selected = element.querySelector('option[selected]') || element.querySelector('option:checked')
		const resolvedSolutionId = selected ? selected.value : element.value
		updateUrlState({ params: currentSelectionParams(resolvedSolutionId), replace: true })
		if (resolvedSolutionId && resolvedSolutionId !== '0') {
			loadSolutionDetails(resolvedSolutionId)
		}
	})
}

export default registerUICompilers
